import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CookieSettingsGuard } from '@teamfoster/sdk/cookie-ngrx';
import { DictionaryGuard } from '@teamfoster/sdk/dictionary-ngrx';
import { ActiveLanguageGuard, LanguageGuard } from '@teamfoster/sdk/language-ngrx';
import { MenuGuard } from '@teamfoster/sdk/menu-ngrx';
import { NotFoundComponent } from './404.component';
import { ActionBarsGuard } from './action-bars/guards';
import { ResetTopbarGuard } from './core/guards/reset-topbar.guard';
import { InitCartGuard } from './shop';
import { DiscountViaUrlGuard } from './shop/guards/discount-via-url.guard';
import { InitCustomerTokenGuard } from './shop/guards/init-customer-token.guard';
import { NewsletterPopupSettingsGuard } from './newsletters/guards/newsletterpopup.guard';
import { ThemesGuard } from './themes/guards';
import { CustomerGuard } from './shop/guards/customer.guard';
import { SocialChannelsGuard } from './social-media/guards';
import { ActiveStorefrontGuard } from './storefronts/guards';

const appGuards = [
  CookieSettingsGuard,
  DictionaryGuard,
  ActionBarsGuard,
  MenuGuard,
  ResetTopbarGuard,
  InitCustomerTokenGuard,
  InitCartGuard,
  NewsletterPopupSettingsGuard,
  ThemesGuard,
  CustomerGuard,
  SocialChannelsGuard,
];

const routes: Routes = [
  {
    path: '',
    canActivate: [ActiveStorefrontGuard, LanguageGuard, ActiveLanguageGuard], // Shop guard
    children: [
      {
        path: 'discount/:discountCode',
        canActivate: [...appGuards],
        pathMatch: 'full',
        loadChildren: () => import('./cart/cart.module').then(m => m.CartModule),
      },
      {
        path: 'cart',
        loadChildren: () => import('./cart/cart.module').then(m => m.CartModule),
        canActivate: [...appGuards],
      },
      {
        path: 'styleguide',
        loadChildren: () => import('./style-guide/style-guide.module').then(m => m.StyleGuideModule),
        canActivate: [...appGuards],
      },
      {
        path: 'account',
        // pathMatch: 'full',
        loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
        canActivate: [...appGuards],
      },
      {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
        canActivate: [...appGuards],
      },
      {
        path: '404',
        component: NotFoundComponent,
        canActivate: [...appGuards],
      },
      {
        path: '500',
        component: NotFoundComponent,
        canActivate: [...appGuards],
      },
      {
        path: 'products',
        loadChildren: () => import('./catalog/catalog.module').then(m => m.CatalogModule),
        canActivate: [...appGuards],
      },
      {
        path: 'collections',
        loadChildren: () => import('./catalog/catalog.module').then(m => m.CatalogModule),
        canActivate: [...appGuards],
      },
      {
        path: 'page',
        loadChildren: () => import('./content/content.module').then(m => m.ContentModule),
        canActivate: [...appGuards],
      },
      {
        path: '',
        loadChildren: () => import('./landing-page/landing-page.module').then(m => m.LandingPageModule),
        canActivate: [...appGuards],
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: '/404',
      },
    ],
  },
];

@NgModule({
  //{ scrollPositionRestoration: 'enabled', initialNavigation: 'enabledBlocking' }
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
